import MockupView from './MockupView'

export default MockupView
